// NavigationInjector.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { store } from "./Store";

export const NavigationInjector = () => {
  const navigate = useNavigate();

  useEffect(() => {
    store.setNavigate(navigate);
  }, [navigate]);

  return null; // This component doesn't render anything
};
